import { getRedirectUrl } from '~packs/purchase-redirect/src/get-redirect-url';

const legacyUrl = window.location.hash;
window.location.replace(getRedirectUrl(legacyUrl));
